import React from "react";
import { Droplets, Wrench, CircleAlert, Wind, Thermometer, Fan } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const services = [{
  title: "ԱՐԲԱՆՅԱԿԱՅԻՆ ՊԱՏԿԵՐՆԵՐԻ ՍՏԱՑՈՒՄ",
  description: "Բարձր լուծաչափով տիեզերական լուսանկարահանում և տվյալների օպերատիվ մշակում գլոբալ մոնիտորինգի համար:",
  icon: Wind,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/0b5fec04-5ef2-4ce3-8071-b11cf19f42a9.png?v=g5l8c9zd8em"
}, {
  title: "ՖՈՏՈԳՐԱՄԵՏՐԻԱԿԱՆ ԱՇԽԱՏԱՆՔՆԵՐ",
  description: "Հայկական առաջին արբանյակի կառավարում և տվյալների բացառիկ հասանելիություն պետական և մասնավոր կարիքների համար:",
  icon: Droplets,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/378ddb09-d53a-4326-bf3c-4f571e45a5ef-1.png?v=9qz1tunfkvb"
}, {
  title: "ՎԵՐԳԵՏՆՅԱ ԿԱՅԱՆՆԵՐ",
  description: "Ճշգրիտ չափագրումներ և եռաչափ մոդելավորում արբանյակային և օդային լուսանկարների հիման վրա:",
  icon: CircleAlert,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/74ed1169-0965-46e6-8a6a-e54b7c39672f.png?v=t21xryrfmo"
}, {
  title: "ՌԵԼԻԵՖԻ ԵՎ ՏԵՂԱՆՔԻ ԹՎԱՅԻՆ ՄՈԴԵԼՆԵՐԻ ՍՏԵՂԾՈՒՄ(DSM/DTM)",
  description: "Տվյալների ընդունման և արբանյակների կառավարման բարձր տեխնոլոգիական ենթակառուցվածքների սպասարկում:",
  icon: Fan,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/980a1bee-9f62-43aa-b4c6-292cb1349691.png?v=ua9c406kzt"
}, {
  title: "ԹՎԱՅԻՆ ՔԱՐՏԵԶՆԵՐԻ ՍՏԵՂԾՈՒՄ ԵՎ ԹԱՐՄԱՑՈՒՄ",
  description: "Ժամանակակից ԳՏՀ տեխնոլոգիաներով ճշգրիտ թվային քարտեզների պատրաստում և պարբերական թարմացում:",
  icon: Wrench,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/1c9f9496-35c1-40a9-8be6-ad7050be7788.png?v=g7o5022em9d"
}, {
  title: "Գեոդեզիական Աշխատանքներ",
  description: "Բարձր ճշտության տեղագրական հանույթ և ինժեներական գեոդեզիա ցանկացած բարդության նախագծերի համար:",
  icon: Thermometer,
  image: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/8a8dd226-d0be-4253-ae85-9bdfcddfc151.png?v=mdboq09h1ti"
}];
function ServiceCard({
  service,
  index
}: {
  service: {
    title: string;
    description: string;
    icon: React.ElementType;
    image: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  const Icon = service.icon;

  // 1. Determine the correct URL once based on the index to keep the JSX clean
  let serviceUrl = "#";
  {/* if (index === 0) serviceUrl = "/SatelliteImageAcquisitionPage";
   else if (index === 1) serviceUrl = "/PhotogrammetryWorksPage";
   else if (index === 2) serviceUrl = "/ElectricStationsPage";
   else if (index === 3) serviceUrl = "/ReliefAndTerrainDigitalModelsCreationPage";
   else if (index === 4) serviceUrl = "/DigitalMapsCreationAndUpdatePage";
   else if (index === 5) serviceUrl = "/GeodeticWorksPage";*/}
  if (index === 0) serviceUrl = "/արբանյակային-պատկերների-ստացում";else if (index === 1) serviceUrl = "/ֆոտոգրամետրիական-աշխատանքներ";else if (index === 2) serviceUrl = "/վերգետնյա-կայաններ";else if (index === 3) serviceUrl = "/գեոդեզիական-աշխատանքներ";else if (index === 4) serviceUrl = "/թվային-քարտեզների-ստեղծում-և-թարմացո";else if (index === 5) serviceUrl = "/ռելիեֆի-և-տեղանքի-թվային-մոդելների-ստ";
  return <div data-index={index} ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      {/* 2. Wrap the entire Card in the Link component */}
      <Link to={serviceUrl} className="block w-full">
        <Card className="text-card-foreground gap-6 rounded-xl py-6 pt-0 group flex flex-col items-center border border-chart-1/20 bg-card text-center transition-all duration-300 w-full h-auto aspect-square md:w-[400px] md:h-[400px] md:aspect-auto hover:border-chart-3/50 hover:shadow-2xl">
          <CardHeader className="flex flex-col items-center pb-4 pt-8">
            
            <div className="mb-4 flex items-center justify-center rounded-lg bg-chart-1/10 text-primary transition-transform duration-500 group-hover:-translate-y-2 group-hover:scale-110 overflow-hidden w-full h-[clamp(200px,60vw,250px)] md:w-[300px] md:h-[250px]"> 
              <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} className="!h-[250px] w-full object-contain" loading="lazy" alt={service.title} />
            </div>
            
            {/* 3. Render just the text for the title, using group-hover to trigger the color change */}
            <CardTitle className="font-semibold font-default text-xl uppercase tracking-wider text-foreground w-full md:w-[320px] group-hover:text-chart-1 transition-colors">
              {service.title}
            </CardTitle>

          </CardHeader>
        </Card>
      </Link>
    </div>;
}
export default function OurPlumbingSpecialties() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  {/*return <section data-section-id="223013" id="մեր-ծառայությունները" className="py-[clamp(60px,10vw,96px)] lg:py-32 text-foreground dark bg-muted">*/}
  {/*<div className="mx-auto max-w-7xl px-[clamp(16px,4vw,24px)] lg:px-8">*/}
  return <section data-section-id="223013" id="մեր-ծառայությունները" className="text-foreground py-[clamp(60px,10vw,96px)] md:py-24 lg:py-32 dark bg-secondary">
    <div className="mx-auto max-w-7xl px-[clamp(16px,4vw,24px)] md:px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-8 flex items-center justify-center gap-4">
            <div className="h-px flex-1 bg-chart-1/30" />
            <h2 className="font-default text-3xl font-bold uppercase tracking-widest sm:text-4xl text-secondary-foreground">
              Մեր Ծառայությունները
            </h2>
            <div className="h-px flex-1 bg-chart-1/30" />
          </div>
          <p className="mt-4 font-default text-lg leading-8 text-primary-foreground">Տիեզերական հեռազննումից մինչև ճշգրիտ քարտեզագրում. մենք տրամադրում ենք բարձրակարգ լուծումներ ռազմավարական նշանակության ոլորտների համար:</p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3 lg:gap-8">
          {services.map((service, index) => <ServiceCard key={service.title} service={service} index={index} />)}
        </div>
      </div>
    </section>;
}